/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  // Metricas de saude da tela de Caixas — fora do payload de inbox de proposito.
  getOverview() {
    return axios.get(`${this.url}/overview`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  getTemplates(inboxId) {
    return axios.get(`${this.url}/${inboxId}/templates`);
  }

  createTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/templates`, { template });
  }

  deleteTemplate(inboxId, templateName) {
    return axios.delete(`${this.url}/${inboxId}/templates/${templateName}`);
  }

  editTemplate(inboxId, templateId, template) {
    return axios.patch(`${this.url}/${inboxId}/templates/${templateId}`, {
      template,
    });
  }

  syncTemplatesManual(inboxId) {
    return axios.post(`${this.url}/${inboxId}/templates/sync`);
  }

  getTemplateUsage(inboxId, periodDays = 30) {
    return axios.get(
      `${this.url}/${inboxId}/templates/usage?period=${periodDays}`
    );
  }

  uploadTemplateMedia(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${this.url}/${inboxId}/templates/upload_media`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  getBusinessProfile(inboxId) {
    return axios.get(`${this.url}/${inboxId}/business_profile`);
  }

  updateBusinessProfile(inboxId, params) {
    return axios.patch(
      `${this.url}/${inboxId}/update_business_profile`,
      params
    );
  }

  testEmailConnection({ kind, config }) {
    return axios.post(`${this.url}/test_email_connection`, { kind, config });
  }
}

export default new Inboxes();
